import {Component, OnDestroy, OnInit} from "@angular/core";
import {ItemPreguntaDTO, PreguntaDTO} from "@DTOS";
import {obtenerIdPreguntaTipo, PreguntasTipoEnum} from "@shared/enums";
import {ItemPreguntaModelDTO, PreguntaModelDTO} from "@Models";
import {EncuestasService} from "../../../../encuestas.service";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {Subscription} from "rxjs";
import {debounceTime, filter, mergeMap, tap} from "rxjs/operators";
import {CommandAsync, ICommand} from "@nahuelmorata/ngx-command";
import {NotificacionServiceEmisor} from "@shared/services";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";


@Component({
    selector: "app-tipo-pregunta-derivador-random",
    templateUrl: "./tipo-pregunta-derivador-random.component.html",
    styleUrls: ["./tipo-pregunta-derivador-random.component.scss"]
})
export class TipoPreguntaDerivadorRandomComponent extends TipoPreguntaComponent implements OnInit, OnDestroy {
    public preguntas: PreguntaDTO[];
    public pregunta: PreguntaModelDTO;
    public colores = {};
    public items: ItemPreguntaModelDTO[] = [];

    public textoItem = "";

    public agregarCmd: ICommand = new CommandAsync(() => this.agregarItem());

    private subs = new Subscription();

    constructor(private tiposPreguntasService: TiposPreguntasService, private encuestasService: EncuestasService,
        private notificacionService: NotificacionServiceEmisor) {
        super();
    }

    public ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit(): void {
        this.preguntas = this.tiposPreguntasService.encuesta?.preguntas || [];
        this.pregunta = this.tiposPreguntasService.preguntaModel || new PreguntaModelDTO(new PreguntaDTO());
        this.colores = this.tiposPreguntasService.colores;
        this.items = this.pregunta.Items.map(item => this.crearItem(item));
    }

    public obtenerId(tipoPregunta: PreguntasTipoEnum): string {
        return obtenerIdPreguntaTipo(tipoPregunta);
    }

    public compararId(item1: PreguntaDTO, item2: number): boolean {
        return item1.id === item2;
    }

    public async agregarItem(): Promise<void> {
        const itemPreguntaDTO = new ItemPreguntaDTO({
            text: this.textoItem.trim()
        });

        this.textoItem = "";
        const itemNuevo = await this.tiposPreguntasService.agregarItemPregunta(this.pregunta.Entidad, itemPreguntaDTO);
        this.items.push(this.crearItem(itemNuevo));
        this.notificacionService.notificarExito("Item agregado correctamente.");
    }

    private crearItem(item: ItemPreguntaDTO): ItemPreguntaModelDTO {
        const model = new ItemPreguntaModelDTO(item);
        this.subs.add(
            model.changed$.pipe(
                filter(Boolean),
                debounceTime(200),
                mergeMap(() => this.encuestasService.guardarItemPregunta(
                    this.tiposPreguntasService.encuesta, this.pregunta.Entidad, model.Entidad
                )),
                tap(() => this.notificacionService.notificarExito("Item modificado correctamente."))
            ).subscribe()
        );
        return model;
    }
}
